import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"



class CategoriaAdmin extends Component {
state = {
  nome:null,
  endereco:null,
  telefone:null,
  error:null,
  success:null,
  unidades:[],
  idtodel:"",
  idtoedit:"",
  idaction:"1",
  iduser:"",
  btndisable:"false"
}

  async loadunidades () {
    const response = await api.post("/unidades");
    this.setState({ unidades: response.data });
  }

  async componentDidMount(){
    this.loadunidades();
  }



  async loadfillunidade (id) {
    const response = await api.post("/unidades/show", {id:id});
    this.setState({ nome: response.data.nome,
    endereco: response.data.endereco,
    telefone: response.data.telefone,
  });

    console.log(this.state);
  }


  unidade = async e => {
    e.preventDefault();
    
    if(this.state.idaction=="2"){
      this.editunidade();
    }else if(this.state.idaction=="3"){
      this.delunidade();
    }else{
      this.addunidade();
    }
      
    
  }


  delunidade = async e => {
    this.setState({ btndisable: true });
    const { nome, endereco,telefone,idtodel } = this.state;
      if (!nome || !endereco || !telefone || !idtodel) {
          this.setState({ error: "Erro !",
        success:null });
        this.setState({ btndisable: false });
        
      } else {
      const { nome } = this.state;
      const response = await api.post("/unidades/delete", { id:idtodel,nome, endereco,telefone  });

        if(response.data.id){
          this.setState({ success: "Unidade Deletada!" , error:null
        , endereco:"", telefone:"", idtodel:"", idaction:"1"  });
          this.loadunidades();
        }

        this.setState({ btndisable: false });

      }
  }


  addunidade = async e => {
    this.setState({ btndisable: true });
    const { nome, endereco,telefone } = this.state;
      if (!nome || !endereco || !telefone) {
          this.setState({ error: "Preencha o nome antes de adicionar um novo!",
        success:null });
        this.setState({ btndisable: false });
          
      }
      else {
      const { nome } = this.state;
      const response = await api.post("/unidades/add", { nome, endereco,telefone  });

        if(response.data.id){
          this.setState({ success: "Unidade Adicionada!" , error:null
        , endereco:"", telefone:""  });
          this.loadunidades();

        }

        this.setState({ btndisable: false });

      }
  }


  editunidade = async e => {
    this.setState({ btndisable: true });

    const { idtoedit,nome, endereco,telefone } = this.state;
    console.log(this.state)
      if ( !idtoedit || !nome || !endereco || !telefone) {
          this.setState({ error: "Preencha o nome antes de editar!",
        success:null });
        this.setState({ btndisable: false });
          
      }
      else {
      const { nome } = this.state;
      const response = await api.post("/unidades/edit", {id:idtoedit, nome, endereco,telefone  });

        if(response.data.id){
          this.setState({ success: "Unidade atualizada!" , error:null
      , endereco:"", telefone:"", idtoedit:"",idaction:"1", nome:""  });
          this.loadunidades();

        }else{
          this.setState({ btndisable: false });
        }
        
        this.setState({ btndisable: false });

      }
  }


  shouldComponentUpdate(nextProps, nextState)
  {
 


    if(nextState.idtoedit!==this.state.idtoedit){
      this.loadfillunidade(nextState.idtoedit);
      
    

    }
    if(nextState.idtodel!==this.state.idtodel){
      this.loadfillunidade(nextState.idtodel);

    

    }

    return true;
  }

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-6 p-4">     

{this.state.idaction=="1" && <h4>Adicionar Nova Unidade</h4> }
{this.state.idaction=="2" && <h4>Atualizar Unidade # {this.state.idtoedit}</h4> }
{this.state.idaction=="3" && <h4>Deletar Unidade # {this.state.idtodel}</h4> }

        <form onSubmit={this.unidade}>

        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
          {this.state.idtoedit!=="" && 
        
        <div class="form-group">
        <label for="exampleFormControlInput1">ID Unidade</label>
        <input type="text" class="form-control" disabled defaultValue={this.state.idtoedit} placeholder="Digite o nome da nova Unidade" />
        </div>
        
        
        }
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" onChange={e => this.setState({ nome: e.target.value })} value={this.state.nome} placeholder="Digite o nome da nova Unidade" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Endereço</label>
                    <input type="text" class="form-control" value={this.state.endereco}  onChange={e => this.setState({ endereco: e.target.value })} placeholder="Digite o Endereço" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone</label>
                    <input type="text" class="form-control" value={this.state.telefone}  onChange={e => this.setState({ telefone: e.target.value })} placeholder="Digite o Nº do Telefone" />
                </div>
                <div class="form-group">
                  {this.state.idaction=="1" && <button class="btn btn-primary mb-2" disabled={this.state.btndisable==true}>Adicionar</button>}
                  {this.state.idaction=="2" && <button class="btn btn-primary mb-2" disabled={this.state.btndisable==true}>Atualizar</button>}
                  {this.state.idaction=="3" && <button class="btn btn-danger mb-2" disabled={this.state.btndisable==true}>Voce deseja deletar?</button>}

                </div>
        </form>














    {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">Endereço

      </th>
      <th class="th-sm">Telefone

      </th>

      <th class="th-sm">Ação

      </th>
    </tr>
  </thead>
  <tbody>
  {this.state.unidades.map(el => (
    <tr>
    <td>{el.nome}</td>
    <td>{el.endereco}</td>
    <td>{el.telefone}</td>
    <td>{el.deleted_at==null && "Ativo"}
    {el.deleted_at!==null && "Desativado"}</td>
    <td>
      <a class="btn btn-primary btn-sm" href="#" onClick={e => this.setState({ idtoedit: el.id, idaction:"2" })}>Editar</a>
      <a class="btn btn-danger btn-sm" href="#" onClick={e =>  this.setState({ idtodel: el.id, idaction:"3" })}>Excluir</a>
    </td>
  </tr>
  ))}
    

   
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(CategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/unidades.js